
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { BaseChart } from '@/components/dashboards/baseChart'
  import { fixPrice } from '@/utils/general'

@Component({})
  export default class UtilityPeriodSales extends BaseChart {
  brief = ''

  // Methods
  mounted () {
    this.getData()
    this.display = true
  }

  @Prop() sales: Record<string, any>
  @Prop() purchases: Record<string, any>
  @Prop() target: Record<string, any>

  getData () {
    if (!this.sales || !this.purchases || !this.target) return
    const sales = this.sales
    const purchases = this.purchases
    const targetSales = this.target

    if (!sales && !purchases) {
      this.series = [0]
      this.chartOptions.fill.colors = this.getBarColor(0)
      return
    }

    let salesAmount = sales?.sales_sale_order_item_aggregate?.aggregate?.sum.amount
    if (!salesAmount) salesAmount = 0

    let purchasesAmount = purchases?.sales_stock_view_aggregate?.aggregate?.sum.total_cost
    if (!purchasesAmount) purchasesAmount = 0

    let utilityAmount = 0

    utilityAmount = salesAmount - purchasesAmount

    let monthlyTarget = targetSales?.settings_process?.[0]?.config?.projectedUtility?.amount
    if (!monthlyTarget) monthlyTarget = 100000000

    const percentage = (utilityAmount / monthlyTarget) * 100

    this.brief = `${fixPrice(utilityAmount)}`
    this.series = [Math.round(percentage)]

    this.chartOptions = {
      stroke: {
        lineCap: 'round',
      },
      plotOptions: {
        radialBar: {
          hollow: {
            size: '65%',
          },
          dataLabels: {
            show: true,
            name: {
              show: true,
              fontSize: '20px',
              fontWeight: 500,
              color: '#737373',
              offsetY: 32,
            },
            value: {
              show: true,
              fontSize: '40px',
              fontWeight: 800,
              color: '#737373',
              offsetY: -17,
            },
          },
        },
      },
      labels: ['Directa'],
      fill: {
        type: 'solid',
        colors: [this.getBarColor(percentage)],
      },
    }
  }

  // Getters

  // Watchers
  @Watch('target', { immediate: true, deep: true })
  @Watch('sales', { immediate: true, deep: true })
  @Watch('purchases', { immediate: true, deep: true })
  onDatesChange () {
    this.display = false
    this.getData()
    this.display = true
  }
  }
